var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"label-tag"},[(_vm.mergedConfig)?_vm._l((_vm.mergedConfig.data),function(label,i){return _c('div',{key:label,staticClass:"label-item"},[_vm._v(" "+_vm._s(label)+" "),_c('div',{style:(`background-color: ${_vm.mergedConfig.colors[i % _vm.mergedConfig.colors.length]};`)})])}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }